// extracted by mini-css-extract-plugin
export default {"mainContainer":"layout_mainContainer__SLH1V","contentContainer":"layout_contentContainer__yPE4E"};